import React, { useEffect, useState } from "react";
import { Grid, Typography, Box, Card, CardContent, Divider, Container, Theme, Button } from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import moment from "moment";

import { ReactComponent as DocSVG } from "../../Images/vetDoctor.svg";
import { ReactComponent as StarSVG } from "../../Images/star.svg";
import { ReactComponent as StarFilledSVG } from "../../Images/starFilled.svg";
import { makeStyles } from "@material-ui/core/styles";
import API from "../../helpers/apiHelpers";

const useStyle = makeStyles((theme: Theme) => ({
    wrapper: {
        marginTop: 90,
        marginBottom: 50,
    },
    leftContentWrapper: {
        width: "50%",
        height: "80%",
        marginTop: "20px",
        [theme.breakpoints.up("md")]: {
            marginLeft: "20px",
            marginTop: "0",
        },
    },
    bullet: {
        display: "inline-block",
        margin: "0 2px",
        transform: "scale(0.8)",
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    cardContent: {
        display: "flex",
        flexDirection: "column",
        width: "260px",
        height: "425px",
        alignItems: "center",
        justifyContent: "space-between"
    },
    docPhoto: {
        display: "flex",
        justifyContent: "center"
    },
    devideBorrder: {
        border: "1px solid #CCCDE5",
        width: "100%"
    }
}));
const VetProfile = () => {
    const classes = useStyle();
    const { profileId } = useParams<any>();
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [education, setEducation] = useState("");
    const [chatFee, setChatFee] = useState(0);
    const [videoFee, setVideoFee] = useState(0);
    const [summary, setSummary] = useState("");
    const [workDays, setWorkDays] = useState([]);
    const [actualImageUrl, setActualImageUrl] = useState("");
    const [averageRating, setAverageRating] = useState(0);

    useEffect(() => {
        API.getProfileById(profileId)
            .then((profile) => {
                setFirstName(profile.firstName);
                setLastName(profile.lastName);
                setEducation(profile.education);
                setChatFee(profile.baseChatOnlyFee);
                setVideoFee(profile.baseVirtualFee);
                setSummary(profile.summary);
                setWorkDays(profile.workDays);
                setActualImageUrl(profile.image);
                setAverageRating(profile.averageRating);
            })
            .catch((err) => {
                enqueueSnackbar(err);
            });
    },[]);

    const handleSelect = () => {
        history.push("/summary");
    };

    return (
        <Container>
            <Grid container className={classes.wrapper}>
                <Grid item xs={12} md={3}>
                    <Card>
                        <Grid container justify="center">
                            <CardContent className={classes.cardContent}>
                                <Box className={classes.docPhoto}>
                                    {
                                        actualImageUrl ?
                                            <img alt="vet profile picture" src={actualImageUrl}style={{borderRadius: "4px", objectFit: "cover"}} width="129" height="129" onError={() => {setActualImageUrl("");}}></img>
                                            :
                                            <DocSVG />
                                    }
                                </Box>
                                <Typography variant="h4"> Dr. {firstName} {lastName} </Typography>
                                <Typography>{education} </Typography>
                                <Divider className={classes.devideBorrder}/>
                                <Typography variant="h4"> Average Rating: {averageRating} </Typography>
                                <Box>
                                    {
                                        averageRating > 0 ? <StarFilledSVG /> :  <StarSVG />
                                    }
                                    {
                                        averageRating > 1 ? <StarFilledSVG /> :  <StarSVG />
                                    }
                                    {
                                        averageRating > 2 ? <StarFilledSVG /> :  <StarSVG />
                                    }
                                    {
                                        averageRating > 3 ? <StarFilledSVG /> :  <StarSVG />
                                    }
                                    {
                                        averageRating > 4 ? <StarFilledSVG /> :  <StarSVG />
                                    }
                                </Box>
                                <Button type="button" onClick={handleSelect} color="secondary" variant="contained">
									Appointment Summary
                                </Button>
                            </CardContent>
                        </Grid>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} container direction="column" wrap="nowrap" className={classes.leftContentWrapper}>
                    <Box marginBottom="20px">
                        <Typography variant="h4">Specialty</Typography>
                        <Typography color="textSecondary">General Practice</Typography>
                    </Box>
                    <Box marginBottom="20px">
                        <Typography variant="h4">Services</Typography>
                        <Typography color="textSecondary">Chat, Video</Typography>
                    </Box>
                    <Box marginBottom="20px">
                        <Typography variant="h4">Base Chat Fee</Typography>
                        <Typography color="textSecondary">{chatFee}</Typography>
                    </Box>
                    <Box marginBottom="20px">
                        <Typography variant="h4">Base Video Fee</Typography>
                        <Typography color="textSecondary">{videoFee}</Typography>
                    </Box>
                    {
                        summary &&
						<Box marginBottom="20px">
						    <Typography variant="h4">Brief Summary</Typography>
						    <Typography color="textSecondary">{summary}</Typography>
						</Box>
                    }
                    {
                        workDays.length ?
                            <Box marginBottom="20px">
                                <Typography variant="h4">Availability</Typography>
                                {
                                    workDays.map((workday) => {
                                        return <Typography key={workday.id} color="textSecondary">
                                            {workday.dayOfWeek.toLowerCase().charAt(0).toUpperCase() + workday.dayOfWeek.toLowerCase().slice(1)}&nbsp;
                                            {moment(`2011-01-01 ${workday.workdayBegins}`).format("h:mm a")}&nbsp;
											-
											&nbsp;{moment(`2011-01-01 ${workday.workdayEnds}`).format("h:mm a")}
                                        </Typography>;
                                    })
                                }
                            </Box>
                            :
                            <Typography>The vet did not filled up his working schedule</Typography>
                    }
                </Grid>
            </Grid>
        </Container>
    );
};

export default VetProfile;
